export const APPLE_APP_STORE_URL = 'https://itunes.apple.com/app/apple-store/id1460663960?pt=298087&ct=mobi&mt=8'
export const GOOGLE_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.aardwegmedia.playpost'

export const GOOGLE_CHROME_EXTENSION_URL = 'https://chrome.google.com/webstore/detail/save-to-playpost/ifnpinjadbboilclldkikcggajgpcdgm'
export const FIREFOX_EXTENSION_URL = 'https://addons.mozilla.org/en-US/firefox/addon/playpost/'
export const OPERA_EXTENSION_URL = 'https://addons.opera.com/nl/extensions/details/save-to-playpost/'

export const INSTAGRAM_URL = 'https://www.instagram.com/playpostapp/'
export const TWITTER_URL = 'https://twitter.com/playpostapp'
export const FACEBOOK_URL = 'https://www.facebook.com/playpostapp/'
export const MEDIUM_URL = 'https://medium.com/playpost'
